<template>
  <div class="w-100 d-flex">
    <div class="mr-2">
      <b-avatar
        size="36"
        class="avatar-border-2 box-shadow-1"
        :src="require('@/assets/images/mascot/dil_small.jpg')"
      />
    </div>
    <div class="chat-body w-100">
      <div class="chat-content chat-bot box-info">
        <h5 class="mb-0">{{ $t('creator.thanksQuestion')}}</h5>

        <span class="text-box-success avenir-medium">{{ $t('creator.talentAnswers') }}</span>
        <div class="d-flex justify-content-end"><b-button class="btn-green" variant="btn-green" @click="openModal()">{{ $t('creator.updateMembership')}}</b-button></div>
      </div>
    </div>
    <modal-membership-group
      v-if="open_modal_plans_group"
      :open_modal_plans_group="open_modal_plans_group" 
      :key="update_modal"
      :month_dad="true"
    />
  </div>
</template>

<script>
import {
  BAvatar,
  BButton
} from 'bootstrap-vue'


export default {
  name: 'upgradePlan',
  components: {
    BAvatar,
    BButton,
    ModalMembershipGroup: () => import('@/views/components/modal/ModalMembershipGroup.vue'),
  },
  props: {
  },
  data() {
    return {
      open_modal_plans_group: false,
      update_modal: 0,
    }
  },
  created() {
  },
  methods: {
    openModal() {
      this.open_modal_plans_group = true;
      this.update_modal += 1;
    },
  },
  watch: {
  }
}
</script>

<style scoped>
.box-info {
  width: 100%;
  max-width: 95% !important;
  background: #DDF8EE !important;
  border: 2px solid #57DAAC !important;
  border-radius: 5px !important;
  padding: 5px;
}
.btn-green {
  color: #fff;
  background-color:  #348267 !important;
}
</style>
